import { z } from 'zod';
import { requiredString } from '../helpers';
/**
 * Salesforce Create Task v1 Configuration Validator
 * Validates Salesforce task creation configuration
 */
export const Salesforce_Create_Task_1_ConfigValidator = z
    .object({
    connection: requiredString('Salesforce Connection is required'),
    campaignMemberId: z.string().optional(),
    whatId: z.string().optional(),
    whoId: z.string().optional()
})
    .refine((data) => {
    return ((data.whoId && data.whoId.trim() !== '') ||
        (data.campaignMemberId && data.campaignMemberId.trim() !== ''));
}, {
    path: ['whoId', 'campaignMemberId'],
    error: 'Either whoId or campaignMemberId must be provided and not empty'
});
//# sourceMappingURL=salesforce-create-task-1.js.map